'use strict';
import { dmEnv } from '@dm/utils';

const cookies = {
  get: (name): string | void => {
    let arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
      return decodeURIComponent(arr[2]);
    }
  },
  set: (name, value, expire?: any) => {
    if (value == null) return;
    const expireTime = !expire && dmEnv.isApp() ? 90 : expire;
    if (!expireTime) {
      document.cookie = name + '=' + encodeURIComponent(value) + ';path=/';
    } else {
      const exp = new Date();
      exp.setTime(exp.getTime() + expireTime * 60 * 1000);
      document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + exp.toUTCString() + ';path=/';
    }
  },
  remove: (name) => {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = cookies.get(name);
    if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString() + ';path=/'; //domain=zhongan.com;
  },
};

export default cookies;
